module.exports = "https://cdn.meeting.tencent.com/assets/events/host/_next/static/images/poster-6-20b7a88e193260e89287f8622b6666e7.jpg";